let initialState = {company:{shopify_shop_name:'', qbo_company_name:''}};
const companyReducer = (state = initialState, action) => {
    switch(action.type){
        case 'SET_COMPANY_DETAILS':
            return {...state, company: action.payload};
         
        default: return state; 
    }
}

export default companyReducer;